export enum ApiActions {
  CLEAR_REQUEST = '@api/CLEAR_REQUEST',
  CLEAR_ALL_REQUESTS = '@api/CLEAR_ALL_REQUESTS',
}
